<template>
  <div class="churn-survey-end">
    <img class="top-visual" :src="require(`@/assets/check-green-happy.svg`)"/>
    <div class="title">תודה!</div>
    <div class="subtitle">התשובות שלך יעזרו לנו להמשיך</div>
    <div class="subtitle">לשפר את השירות</div>
  </div>
</template>

<script>

export default {
  name: 'ChurnSurveyEnd',
};

</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.churn-survey-end {
  text-align: center;
  .top-visual {
    height: 227px;
    margin-top: 20px;
    margin-bottom: 22px;
  }

  .title {
    margin-bottom: 15px;
    font-size: 24px;
    line-height: 34px;
    font-weight: bold;
  }

  .subtitle {
    font-size: 18px;
    line-height: 28px;
  }
}
</style>
